import { render } from "./OrderPaymentQris.vue?vue&type=template&id=5e9aeef2&scoped=true"
import script from "./OrderPaymentQris.vue?vue&type=script&lang=js"
export * from "./OrderPaymentQris.vue?vue&type=script&lang=js"

import "./OrderPaymentQris.vue?vue&type=style&index=0&id=5e9aeef2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9aeef2"]])

export default __exports__